import callApi from "helpers/callApi";

const PROJECTS = new Set(["LTax", "LTax_agent", "LEPR", "LAuthorize", "LInvoice"]);

export function normalizeStartGuideStatus(project, body) {
  const raw = body?.steps && typeof body.steps === "object" ? body.steps : {};
  const steps = {};
  Object.entries(raw).forEach(([id, step]) => {
    const complete = Boolean(step?.complete);
    steps[String(id)] = {
      complete,
      skipped: Boolean(step?.skipped) && !complete,
      locked: Boolean(step?.locked),
      lockReason: step?.lockReason || step?.lock_reason || "",
    };
  });
  return {
    project,
    show_user_guide: Boolean(body?.show_user_guide),
    steps,
    loaded: true,
    error: null,
  };
}

async function readBody(response) {
  try {
    return await response.json();
  } catch {
    return null;
  }
}

export async function requestStartGuide(project) {
  if (!PROJECTS.has(project)) {
    return {
      project,
      show_user_guide: false,
      steps: {},
      loaded: true,
      error: `Unknown project: ${project}`,
    };
  }
  const response = await callApi("/user/start_guide", "GET", { project });
  if (!response?.ok) {
    return {
      project,
      show_user_guide: false,
      steps: {},
      loaded: true,
      error: response?.errorMessage || "Error",
    };
  }
  return normalizeStartGuideStatus(project, await readBody(response));
}

export async function requestStartGuideSkip(project, stepId) {
  const response = await callApi("/user/start_guide/skip", "POST", {
    project,
    stepId,
  });
  if (!response?.ok) {
    return { error: response?.errorMessage || "Error" };
  }
  return { status: normalizeStartGuideStatus(project, await readBody(response)), error: null };
}

const inflight = new Map();

export function loadStartGuide(project, { fresh = false } = {}) {
  if (!project) return Promise.resolve(null);
  if (!fresh) {
    const pending = inflight.get(project);
    if (pending) return pending;
  }
  const job = requestStartGuide(project).finally(() => {
    if (inflight.get(project) === job) inflight.delete(project);
  });
  inflight.set(project, job);
  return job;
}
